 
import React from 'react';
import { useHistory, Route, Switch, Redirect, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { PERMISSION, PRIVATE_PATH } from '../../../constants';
import SidebarWrapper from '../../../sections/SidebarWrapper';
import FlexFacilityProfessionals from './FlexFacilityProfessionals';
import { user } from '../../../redux/user';
import ProtectedRoute from '../../../sections/ProtectedRoute';
import utils from '../../../utils/utils';

const FlexFacilitiesWrapper = () => {
	const history = useHistory();
	const userData = useSelector(user, shallowEqual);

	const { facilityId, managementCompanyId } = useParams();
	const facility = userData?.facilitiesEnabled?.find((_facility) => _facility.id === facilityId);

	const sidebarItems = [
		/* {
			label: 'Facility Details',
			editTitle: 'Edit Details',
			isEditing: false,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/facilities/${facilityId}/facility-details`,
			editText: 'Edit Details',
			className: 'details-header'
		}, */
		{
			label: 'Professionals',
			editTitle: facility?.label ? `Professionals - ${facility.label}` : 'Professionals',
			isEditing: true,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/facilities/${facilityId}/professionals`,
			isDisabled: !utils.isAuthorizedExact(PERMISSION.INTERNAL_STAFF, userData.permissionsByFacility[facilityId]),
			className: 'flex-facility-title'
		} /* ,
		{
			label: 'Settings',
			editTitle: facility?.label ? `Settings - ${facility.label}` : 'Settings',
			isEditing: true,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/facilities/${facilityId}/settings`,
			isDisabled: !utils.isAuthorizedExact(
				PERMISSION.WORKFORCE_LOCATIONS_VIEW,
				userData.managementCompanyPermissions[managementCompanyId]
			),
			className: 'flex-credentials-title'
		} */
	];

	const handleBackToProfessionalsList = () => {
		history.push({
			pathname: PRIVATE_PATH.WORKFORCE_PAGE,
			state: { tab: 'locations' }
		});
	};

	return (
		<SidebarWrapper
			sidebarTitle="Manage Location"
			sidebarItems={sidebarItems}
			backTitle="Back to Workforce"
			backAction={handleBackToProfessionalsList}
			className="flex-professionals-sidebar"
		>
			<Switch>
				{/* <ProtectedRoute
					exact
					key="facility-details"
					component={FlexProfessionalsEmployeeDetails}
					pathPermission={PERMISSION.WORKFORCE_PROFESSIONAL_VIEW}
					userPermissions={userData.managementCompanyPermissions[managementCompanyId]}
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/facilities/:facilityId/facility-details`}
				/> */}
				<ProtectedRoute
					exact
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/facilities/:facilityId/professionals`}
					key="professionals"
					component={FlexFacilityProfessionals}
					pathPermission={PERMISSION.INTERNAL_STAFF}
					userPermissions={userData.permissionsByFacility[facilityId]}
				/>
				{/* <ProtectedRoute
					exact
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/facilities/:facilityId/settings`}
					key="settings"
					component={FlexProfessionalLocations}
					pathPermission={PERMISSION.WORKFORCE_LOCATIONS_VIEW}
					userPermissions={userData.managementCompanyPermissions[managementCompanyId]}
					professionalName={`${professional?.first_name || ''} ${professional?.last_name || ''}`}
				/> */}
				<Route path="/*" render={() => <Redirect to="/404" />} />
			</Switch>
		</SidebarWrapper>
	);
};

export default FlexFacilitiesWrapper;
